<template>
  <div>
    <div>
      <apexchart
        width="95%"
        type="bar"
        ref="chart"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import fr from "apexcharts/dist/locales/fr.json";
Vue.component("apexchart", VueApexCharts);

var colors = ["#3FC5F0"];

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    chartDatas: {
      type: Object,
      required: false,
      default: function() {
        return {};
      },
    },
  },
  watch: {
    chartDatas: {
      deep: true,
      handler(newValue) {
        var x = newValue.dates;
        var y = newValue.graph_ventes;
        this.basechart(x, y);
      },
    },
  },
  data: function() {
    return {
      numb: [],
      options: {},
      series: [],
    };
  },
  methods: {
    changetest() {
      this.$emit("changeView", "dsqdsqdsq");
    },
    basechart(x, y) {
      this.options = {
        xaxis: {
          type: "datetime",
          categories: x,
          labels: {
            format: "dd MMM",
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: true,
          },
        },
        chart: {
          type: "bar",
          height: 370,
          locales: [fr],
          defaultLocale: "fr",
          events: {
            click: (event, chartcontext, config) => {
              console.log(x[config.dataPointIndex]);
              this.$emit("changeDate", x[config.dataPointIndex]);
            },
          },
        },
        title: {
          text: "Nombres de ventes",
          align: "left",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
        },
        colors: colors,

        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
              rotate: -45,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val;
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
      };
      this.series = [
        {
          name: "Nombres de ventes",
          data: y,
        },
      ];

      try {
        // this.$refs.chart.chart.setLocale("fr");
        this.$refs.chart.updateSeries(this.series, true);
        this.$refs.chart.updateOptions(this.options, false, true);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
